(function () {
  'use strict';

  function initShowMore(root) {
    var btn = root.querySelector('[data-smile-reviews-more]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-smile-review-item][hidden]').forEach(function (item) {
        item.hidden = false;
        item.classList.remove('is-collapsed');
      });
      btn.hidden = true;
    });
  }

  function ensureLightbox() {
    var box = document.getElementById('smile-lightbox');
    if (box) return box;

    box = document.createElement('div');
    box.id = 'smile-lightbox';
    box.className = 'smile-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    var i18n = window.smileReviewsI18n || {};
    box.setAttribute('aria-label', i18n.lightboxLabel || 'Review photo');
    box.innerHTML =
      '<button type="button" class="smile-lightbox__close" aria-label="' +
      (i18n.lightboxClose || 'Close') +
      '">&times;</button>' +
      '<img class="smile-lightbox__img" alt="">';
    document.body.appendChild(box);

    function close() {
      box.classList.remove('is-open');
      box.querySelector('.smile-lightbox__img').removeAttribute('src');
    }

    box.querySelector('.smile-lightbox__close').addEventListener('click', close);
    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });

    return box;
  }

  function initLightbox(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-smile-lightbox]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-smile-lightbox');
      if (!url) return;
      var box = ensureLightbox();
      var img = box.querySelector('.smile-lightbox__img');
      var i18n = window.smileReviewsI18n || {};
      img.src = url;
      img.alt = i18n.lightboxPhotoAlt || 'Enlarged review photo';
      box.classList.add('is-open');
    });
  }

  function initAnchorScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-smile-reviews-anchor], a.smile-review-badge');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try {
        history.replaceState(null, '', href);
      } catch (err) {}
    });
  }

  function getSlideWidth(scroller) {
    var slide = scroller.querySelector('[data-smile-featured-slide]');
    if (!slide) return scroller.clientWidth;
    var styles = window.getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function initFeaturedCarousel(root) {
    var scroller = root.querySelector('[data-smile-featured-scroller]');
    if (!scroller) return;

    var track = root.querySelector('[data-smile-featured-track]') || scroller;
    var prev = root.querySelector('[data-smile-featured-prev]');
    var next = root.querySelector('[data-smile-featured-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var ms = parseInt(root.getAttribute('data-autoplay-ms') || '4500', 10);
    var resumeDelay = 8000;
    var timer = null;
    var resumeTimer = null;
    var paused = false;
    var inView = false;

    function scrollByDir(dir) {
      var amount = getSlideWidth(scroller) * dir;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var nextLeft = scroller.scrollLeft + amount;
      if (dir > 0 && nextLeft >= max - 4) {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && scroller.scrollLeft <= 4) {
        scroller.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        scroller.scrollBy({ left: amount, behavior: 'smooth' });
      }
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function clearResume() {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function start() {
      stop();
      if (!autoplay || paused || !inView) return;
      timer = setInterval(function () {
        scrollByDir(1);
      }, ms);
    }

    function pauseNow() {
      paused = true;
      clearResume();
      stop();
    }

    function resumeSoon() {
      clearResume();
      resumeTimer = setTimeout(function () {
        paused = false;
        start();
      }, resumeDelay);
    }

    function resumeNow() {
      clearResume();
      paused = false;
      start();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        pauseNow();
        scrollByDir(-1);
        resumeSoon();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        pauseNow();
        scrollByDir(1);
        resumeSoon();
      });
    }

    // Pause while reading: hover / focus / touch anywhere on the carousel
    track.addEventListener('mouseenter', pauseNow);
    track.addEventListener('mouseleave', resumeNow);
    track.addEventListener('focusin', pauseNow);
    track.addEventListener('focusout', function (e) {
      if (track.contains(e.relatedTarget)) return;
      resumeSoon();
    });
    track.addEventListener('touchstart', pauseNow, { passive: true });
    track.addEventListener('pointerdown', pauseNow);
    scroller.addEventListener('scroll', function () {
      pauseNow();
      resumeSoon();
    }, { passive: true });

    if (autoplay && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          inView = !!(entry && entry.isIntersecting && entry.intersectionRatio > 0.35);
          if (inView) start();
          else stop();
        },
        { threshold: [0, 0.35, 0.7] }
      );
      observer.observe(root);
    } else if (autoplay) {
      inView = true;
      start();
    }
  }

  function parsePagesConfig(root) {
    var node = root.querySelector('[data-smile-reviews-pages]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function reviewItemId(item) {
    return item.getAttribute('data-review-id') || '';
  }

  function fetchExtraReviewPages(root) {
    var cfg = parsePagesConfig(root);
    var list = root.querySelector('[data-smile-reviews-list]');
    if (!cfg || !list || !cfg.pages || cfg.pages <= 1) {
      return Promise.resolve();
    }

    var sectionId = cfg.sectionId || root.getAttribute('data-section-id');
    var pageParam = cfg.pageParam || 'page';
    var seen = {};
    list.querySelectorAll('[data-smile-review-item]').forEach(function (item) {
      var id = reviewItemId(item);
      if (id) seen[id] = true;
    });

    var chain = Promise.resolve();
    for (var page = 1; page <= cfg.pages; page += 1) {
      if (page === (cfg.current || 1)) continue;
      chain = chain.then(
        (function (pageNum) {
          return function () {
            var url = new URL(window.location.pathname, window.location.origin);
            url.searchParams.set('sections', sectionId);
            url.searchParams.set(pageParam, String(pageNum));
            return fetch(url.toString())
              .then(function (res) {
                return res.json();
              })
              .then(function (json) {
                var html = json && json[sectionId];
                if (!html) return;
                var wrap = document.createElement('div');
                wrap.innerHTML = html;
                var remoteList = wrap.querySelector('[data-smile-reviews-list]');
                var remotePage = remoteList
                  ? parseInt(remoteList.getAttribute('data-current-page') || '0', 10)
                  : 0;
                if (remotePage && remotePage !== pageNum) {
                  return;
                }
                var items = wrap.querySelectorAll('[data-smile-review-item]');
                var added = 0;
                items.forEach(function (item) {
                  var id = reviewItemId(item);
                  if (id && seen[id]) return;
                  if (id) seen[id] = true;
                  list.appendChild(item);
                  added += 1;
                });
                if (added === 0) {
                  return Promise.reject(new Error('smile-reviews-no-new-page'));
                }
              });
          };
        })(page)
      );
    }
    return chain.catch(function (err) {
      if (err && err.message === 'smile-reviews-no-new-page') return;
    });
  }

  function initAllReviews(root) {
    if (root.getAttribute('data-smile-all-ready') === 'true') return;
    root.setAttribute('data-smile-all-ready', 'true');

    var list = root.querySelector('[data-smile-reviews-list]');
    if (!list) return;

    var pageSize = parseInt(root.getAttribute('data-page-size') || '12', 10) || 12;
    var moreWrap = root.querySelector('[data-smile-reviews-more-wrap]');
    var moreBtn = root.querySelector('[data-smile-reviews-more]');
    var emptyEl = root.querySelector('[data-smile-reviews-empty]');
    var countEl = root.querySelector('[data-smile-reviews-count]');
    var sortEl = root.querySelector('[data-smile-reviews-sort]');
    var state = {
      rating: 'all',
      media: 'all',
      sort: (sortEl && sortEl.value) || 'newest',
      visible: pageSize
    };

    function items() {
      return Array.prototype.slice.call(list.querySelectorAll('[data-smile-review-item]'));
    }

    function dedupeDom() {
      var seen = {};
      items().forEach(function (item) {
        var id = reviewItemId(item);
        if (!id) return;
        if (seen[id]) {
          item.remove();
          return;
        }
        seen[id] = true;
      });
    }

    function matches(item) {
      var rating = Math.round(parseFloat(item.getAttribute('data-rating') || '0') || 0);
      var mediaAttr = item.getAttribute('data-has-media');
      var hasMedia = mediaAttr === '1' || mediaAttr === 'true';
      if (state.rating !== 'all' && rating !== parseInt(state.rating, 10)) return false;
      if (state.media === 'with' && !hasMedia) return false;
      if (state.media === 'without' && hasMedia) return false;
      return true;
    }

    function compare(a, b) {
      var aCreated = parseInt(a.getAttribute('data-created') || '0', 10) || 0;
      var bCreated = parseInt(b.getAttribute('data-created') || '0', 10) || 0;
      var aRating = Math.round(parseFloat(a.getAttribute('data-rating') || '0') || 0);
      var bRating = Math.round(parseFloat(b.getAttribute('data-rating') || '0') || 0);
      switch (state.sort) {
        case 'oldest':
          return aCreated - bCreated;
        case 'highest':
          if (bRating !== aRating) return bRating - aRating;
          return bCreated - aCreated;
        case 'lowest':
          if (aRating !== bRating) return aRating - bRating;
          return bCreated - aCreated;
        case 'newest':
        default:
          return bCreated - aCreated;
      }
    }

    function setItemVisible(item, visible) {
      if (visible) {
        item.hidden = false;
        item.classList.remove('is-collapsed');
      } else {
        item.hidden = true;
        item.classList.add('is-collapsed');
      }
    }

    function apply() {
      dedupeDom();
      var all = items();
      var matched = all.filter(matches).sort(compare);

      all.forEach(function (item) {
        setItemVisible(item, false);
      });

      matched.forEach(function (item) {
        list.appendChild(item);
      });

      var showCount = Math.min(state.visible, matched.length);
      matched.forEach(function (item, index) {
        setItemVisible(item, index < showCount);
      });

      if (countEl) {
        if (matched.length === 0) {
          countEl.hidden = true;
        } else {
          countEl.hidden = false;
          var i18nEl = root.querySelector('[data-smile-reviews-i18n]');
          var showingTpl = 'Showing {{ shown }} of {{ total }} reviews';
          try {
            if (i18nEl) {
              var i18n = JSON.parse(i18nEl.textContent || '{}');
              if (i18n.showing_count) showingTpl = i18n.showing_count;
            }
          } catch (e) {}
          countEl.textContent = showingTpl
            .replace(/\{\{\s*shown\s*\}\}/g, String(showCount))
            .replace(/\{\{\s*total\s*\}\}/g, String(matched.length));
        }
      }

      if (emptyEl) emptyEl.hidden = matched.length > 0;
      if (moreWrap) moreWrap.hidden = showCount >= matched.length;
    }

    root.querySelectorAll('[data-smile-filter-rating]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.rating = btn.getAttribute('data-smile-filter-rating') || 'all';
        state.visible = pageSize;
        root.querySelectorAll('[data-smile-filter-rating]').forEach(function (el) {
          var on = el === btn;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    root.querySelectorAll('[data-smile-filter-media]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.media = btn.getAttribute('data-smile-filter-media') || 'all';
        state.visible = pageSize;
        root.querySelectorAll('[data-smile-filter-media]').forEach(function (el) {
          var on = el === btn;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        state.sort = sortEl.value || 'newest';
        state.visible = pageSize;
        apply();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.visible += pageSize;
        apply();
      });
    }

    apply();
    fetchExtraReviewPages(root).then(function () {
      apply();
    });
  }

  function boot() {
    document.querySelectorAll('[data-smile-reviews]').forEach(function (root) {
      initShowMore(root);
      initLightbox(root);
    });
    document.querySelectorAll('[data-smile-featured]').forEach(function (root) {
      initLightbox(root);
      initFeaturedCarousel(root);
    });
    document.querySelectorAll('[data-smile-all-reviews]').forEach(function (root) {
      initLightbox(root);
      initAllReviews(root);
    });
    initAnchorScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
